// extracted by mini-css-extract-plugin
module.exports = {"ExperienceHeader":"lo_a pz_a pz_x pz_j pz_ri pz_fc pz_so","ExperienceHeader__sep":"lo_b","ExperienceHeader__author":"lo_c pz_tc"};